import { render, staticRenderFns } from "./EmployeesEditor.vue?vue&type=template&id=e6830de8&scoped=true&"
import script from "./EmployeesEditor.vue?vue&type=script&lang=ts&"
export * from "./EmployeesEditor.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeesEditor.vue?vue&type=style&index=0&id=e6830de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6830de8",
  null
  
)

export default component.exports